import { Box, SxProps, Typography, TypographyProps } from '@mui/material';
import { useState } from 'react';
import zeplinColor from 'theme/Color';

const ClientAvatar = ({
  profilePicture,
  clientName,
  sx,
  typographyVariant = 'responsiveBody2',
}: {
  profilePicture?: string;
  clientName?: string;
  sx?: SxProps;
  typographyVariant?: TypographyProps['variant'];
}) => {
  const [imageError, setImageError] = useState(false);

  return (
    <Box
      sx={{
        ...sx,
        borderRadius: '50%',
        overflow: 'hidden',
        flexShrink: 0,
        backgroundColor: zeplinColor.Brand1,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'relative',
        containerType: 'inline-size',
      }}
    >
      {profilePicture && !imageError ? (
        <img
          src={profilePicture}
          alt=''
          width='100%'
          height='100%'
          style={{ objectFit: 'cover' }}
          onError={() => setImageError(true)}
        />
      ) : clientName ? (
        <Typography
          variant={typographyVariant}
          sx={{
            color: zeplinColor.Neutral1,
            fontSize: '40cqi',
            fontWeight: 600,
            lineHeight: '24px',
          }}
        >
          {clientName.charAt(0).toUpperCase()}
        </Typography>
      ) : null}
    </Box>
  );
};

export default ClientAvatar;
